var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Oh no!")]),_c('p',[_vm._v("You tried to access a page, which does not exist.")]),_c('p',[_vm._v("Please reload the page and navigate by the top navigation bar.")])])
}]

export { render, staticRenderFns }